/* Storefront filtering via the Section Rendering API.
 * The form is a real GET form — this only intercepts it so the grid can swap
 * without a full page load. With JS off, the noscript Apply button submits it.
 */
(function () {
  'use strict';

  class Facets extends HTMLElement {
    connectedCallback() {
      this.form = this.querySelector('[data-facet-form]');
      if (!this.form) return;
      this.sectionId = this.dataset.sectionId;

      this.form.addEventListener('change', () => this.submit());
      this.form.addEventListener('submit', (event) => {
        event.preventDefault();
        this.submit();
      });

      const toggle = this.querySelector('[data-facet-toggle]');
      if (toggle) {
        toggle.addEventListener('click', () => {
          const open = this.dataset.open === 'true';
          this.dataset.open = open ? 'false' : 'true';
          toggle.setAttribute('aria-expanded', open ? 'false' : 'true');
        });
      }

      window.addEventListener('popstate', () => this.render(window.location.search, false));
    }

    submit() {
      const params = new URLSearchParams(new FormData(this.form));
      // Drop empty values so the URL stays readable and shareable.
      Array.from(params.entries()).forEach(function (entry) {
        if (entry[1] === '') params.delete(entry[0]);
      });
      const search = '?' + params.toString();
      this.render(search, true);
    }

    render(search, push) {
      if (this.controller) this.controller.abort();
      this.controller = new AbortController();
      this.dataset.loading = 'true';

      const base = window.location.pathname;
      const url = base + search + (search.indexOf('?') === 0 ? '&' : '?') + 'section_id=' + this.sectionId;

      fetch(url, { signal: this.controller.signal })
        .then(function (res) { return res.text(); })
        .then((text) => {
          const doc = new DOMParser().parseFromString(text, 'text/html');

          const incomingGrid = doc.querySelector('[data-results-grid]');
          const currentGrid = document.querySelector('[data-results-grid]');
          if (incomingGrid && currentGrid) currentGrid.innerHTML = incomingGrid.innerHTML;

          const incomingFacets = doc.querySelector('tb-facets');
          if (incomingFacets) {
            const openState = this.dataset.open;
            this.innerHTML = incomingFacets.innerHTML;
            this.dataset.open = openState;
            this.form = this.querySelector('[data-facet-form]');
          }

          const incomingPagination = doc.querySelector('[data-results-pagination]');
          const currentPagination = document.querySelector('[data-results-pagination]');
          if (currentPagination) currentPagination.innerHTML = incomingPagination ? incomingPagination.innerHTML : '';

          if (push) window.history.pushState({}, '', base + search);
          this.dataset.loading = 'false';

          const heading = document.querySelector('[data-results-grid]');
          if (heading) heading.setAttribute('aria-busy', 'false');
        })
        .catch((err) => {
          this.dataset.loading = 'false';
          if (err.name !== 'AbortError') window.location.search = search;
        });
    }
  }

  if (!customElements.get('tb-facets')) customElements.define('tb-facets', Facets);
})();
